import { useState, useContext } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { AppContext, EMPTY_STRING } from 'commons-ui';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
import _startswith from 'lodash/startsWith';
import queryString from 'query-string';
import { SelectedUserType } from '../../../helper';
import useService from '../../../useService';

const useUserDetails = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const { requestUserData, requestUpdateUserSegmentToVip } = useService();
	const { path } = useRouteMatch();

	const handleFormSubmit = async (selectedUser: SelectedUserType) => {
		if (_isEmpty(selectedUser)) {
			showAlert('At least one of the fields is required', { type: 'error' });
		} else {
			setShowLoader(true);
			let selectionType: string = EMPTY_STRING;
			let selectedValue: string | number = EMPTY_STRING;
			const { email, uid, phone, addToStatic } = selectedUser;
			if (!_isNil(uid) && _isNumber(uid)) {
				selectionType = 'uid';
				selectedValue = uid;
			} else if (!_isNil(phone) && !_isEmpty(phone)) {
				selectionType = 'phone';
				selectedValue = _startswith(phone, '+91') ? phone : `+91${phone}`;
			} else if (!_isNil(email) && !_isEmpty(email)) {
				selectionType = 'email';
				selectedValue = email;
			}
			if (_isEmpty(selectionType) || (!_isNumber(selectedValue) && _isEmpty(selectedValue))) {
				showAlert('At least one of the fields is required', { type: 'error' });
				setShowLoader(false);
			} else {
				try {
					const userDetails = await requestUserData(selectionType, selectedValue);
					let showList: boolean = true;
					let zupeeUserId: number = 0;
					if (userDetails && userDetails.zupeeUserId !== null) {
						zupeeUserId = userDetails.zupeeUserId;
					}
					if (zupeeUserId === 0) {
						showList = false;
						showAlert('Unable to fetch user data', { type: 'error' });
					}
					setShowLoader(false);
					if (showList) {
						let addToStaticCsv: boolean = true;
						if (_isNil(addToStatic) || !addToStatic) {
							addToStaticCsv = false;
						}
						const response = await requestUpdateUserSegmentToVip(zupeeUserId, addToStaticCsv, showAlert);
						if (response) {
							history.push({
								pathname: `${path}/listUserSegments`,
								search: `?${queryString.stringify({ ['zupeeUserId' || EMPTY_STRING]: zupeeUserId })}`
							});
						}
					}
				} catch (error: any) {
					showAlert(error.error || 'User not found', { type: 'error' });
					setShowLoader(false);
				}
			}
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { showLoader, setShowLoader, handleFormCancel, handleFormSubmit };
};
export default useUserDetails;
